import { CountryCode } from "@vygruppen/vy-train-map";
import { UserRole } from "shared/types/roles";
import { useDropsRole } from "stores/useDropsRole";

export function useCountryCodeForDropsRole(): CountryCode {
  const { role } = useDropsRole();

  switch (role) {
    case UserRole.personellstyrerkond:
    case UserRole.personellstyrerlok:
    case UserRole.personellstyrervest:
    case UserRole.personellstyrerekstra:
    case UserRole.vaktleder:
    case UserRole.materiellstyrerlokal:
    case UserRole.materiellstyrerregion:
    case UserRole.okm:
    case UserRole.trafikkplanlegger:
    case UserRole.trafikkplanlegger60:
    case UserRole.trafikkplanlegger63:
    case UserRole.lokleder1:
    case UserRole.lokleder2:
    case UserRole.transportleder:
    case UserRole.oks:
      return "NO";

    case UserRole.driftledningen:
      return "SE";
  }
}
